import { Loader2 } from 'lucide-react';

export const LoadingScreen = () => {
  return (
    <div className='w-full h-screen-minus-padding flex items-center justify-center'>
      <Loader2 className='w-24 h-24 animate-spin stroke-greenLight' />
    </div>
  );
};
